import { Link } from "@reach/router";
import { S3_ENDPOINT } from "../../utils";
import React from "react";

const VideoBanner = ({ home_video }) => {
  return (
    <div className="landing-hero video-banner">
      {/* Darkens hero for contrast; sits above video */}
      <div className="video-banner-tone" aria-hidden="true" />
      <div className="video-container">
        <video
          className="mw-100 w-100 shadow video"
          autoPlay
          data-autoplay
          playsInline
          loop
          muted
          data-object-fit="cover"
          poster="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcert-features-3.jpg"
        >
          <source src={home_video} type="video/mp4" />
        </video>
      </div>
      <div className="video-overlay d-block position-relative">
        <div
          className="h-100 px-4 px-md-5 video-banner-overlay-inner pt-4 pt-sm-5 pb-md-5"
          style={{
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <div className="video-banner-row row h-100 align-items-start align-items-md-end pb-md-4">
            {/* Copy first on mobile so headline + CTAs sit above logo */}
            <div className="video-banner-copy text-white col-12 col-md-6 ps-md-0">
              <h1 className="h2 mb-3 mb-md-4 mt-1 mt-md-0">
                Empieza a construir una carrera haciendo lo que amas
              </h1>
              <h2 className="h5 fw-normal text-white lh-base mb-5 subtitle-opacity-banner">
                Certificaciones diseñadas para ayudarte a enseñar con técnica, claridad y propósito.
              </h2>
              <div className="row g-3 cta-group mt-5">
                <div className="col-12 col-md-6 mb-4">
                  <Link
                    id="main-cta"
                    to="/live"
                    className="btn btn-accent w-100"
                  >
                    <span className="h6">En vivo</span>
                  </Link>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <Link to="/ondemand" className="btn btn-dark w-100">
                    <span className="h6">On demand</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 video-banner-logo-col d-flex pt-4 pt-md-0 pb-2 pb-md-3 justify-content-center justify-content-md-end align-items-md-end">
              <img
                src="https://thebodymethod.s3.us-west-1.amazonaws.com/tbm-logo-mtl.png"
                className="video-banner-mtl-logo img-fluid d-block mb-2 mb-md-0"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoBanner;
